import type { ReactNode } from 'react';
import MainMenu from '../MainMenu/MainMenu';
import ToastContainer from '../ToastContainer/ToastContainer';
import ErrorModalContainer from '../ErrorModalContainer/ErrorModalContainer';
import { useRetrieveUser } from '../../hooks/useRetrieveUser';

type PublicCatalogLayoutProps = {
  children: ReactNode;
  brandLogoUrl?: string;
  brandName?: string;
};

const PublicCatalogLayout = ({ children, brandLogoUrl, brandName }: PublicCatalogLayoutProps) => {
  useRetrieveUser();

  return (
    <div className="eateliers-brand lookbook-shell text-foreground">
      <MainMenu brandLogoUrl={brandLogoUrl} brandName={brandName} />
      {children}
      <ToastContainer />
      <ErrorModalContainer />
    </div>
  );
};

export default PublicCatalogLayout;
